import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../Assets/vlogo.png';
import ChatBox from '../Chatbox/Chatbox';

const Navbar = () => {
    const location = useLocation();
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);

    // Paths for "Our Company"
    const ourCompanyPaths = [
        '/',
        '/Overview',
        '/Team',
        '/Blog',
        '/Milestone',
    ];

    // Paths for "Technologies"
    const technologiesPaths = [
        '/network',
        '/Wired',
        '/Radio',
        '/core',
        '/ML',
        '/Software',
    ];

    // Paths for "Solutions"
    const solutionsPaths = [
        '/Solution1',
        '/Fuel-monitoring',
        '/Battery-management',
        '/AQUA',
        '/AMRS',
        '/Retrofit-AMR-solutions',
        '/Prepaid-meter-solution',
        '/Street-light-control',
        '/Water-quality-management-solution',
        '/Management-of-lights-air-conditioning-fire-detection-surveillance',
        '/Vehicle-Tracking-System',
        '/fuel-and-fleet-management',
        '/Person-tracking-system',
        '/Weather-Monitoring',
        '/Burgular-Alarm-System',
        '/Energy-monitoring-system',
        '/Parking-Management',
        '/Visitor-Management',
        '/Food-chain-industries',
        '/Fire-detection',
        '/PMS-for-food-grade-industries',
        '/Telecom',
        '/GIM',
        '/Airconditioner'
    ];

    // Paths for "Product"
    const productPaths = [
        '/Product',
        '/remote-gateways',
        '/Data-transfer-unit',
        '/rfid-tag',
        '/RFID-Reader',
        '/Asset-Monitoring-System',
        '/Metro-Water-Quality',
        '/Temperature-Monitoring-For-Cold-Storage',
        '/Temperature-Monitoring-For-Food-and-Transport',
        '/FuelSensor',
        '/lora-based-water-meter',
    ];

    // Check if the current path matches any sub-routes
    const isOurCompanyActive = ourCompanyPaths.includes(location.pathname);
    const isTechnologiesActive = technologiesPaths.includes(location.pathname);
    const isSolutionsActive = solutionsPaths.includes(location.pathname);
    const isProductActive = productPaths.includes(location.pathname);

    // Handle scroll behavior
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
            setPrevScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [prevScrollPos]);

    return (
        <>
            <nav className={`navigation ${visible ? 'visible' : 'hidden'}`}>
                <div className="logo">
                    <NavLink to="/" className="logo-link">
                        <img src={logo} alt="Company Logo" className="logo-image" />
                    </NavLink>
                </div>
                <div className="dropdown">
                    <NavLink
                        to="/"
                        end
                        className={({ isActive }) =>
                            `dropdown-button ${isActive || isOurCompanyActive ? 'active' : ''}`
                        }
                    >
                        Our Company
                    </NavLink>
                    <div className="dropdown-content single-column">
                        <NavLink to="/Overview">Overview</NavLink>
                        <NavLink to="/Team">Team</NavLink>
                        <NavLink to="/Milestone">Journey So Far</NavLink>
                        <NavLink to="/Blog">Blog</NavLink>
                    </div>
                </div>
                <div className="dropdown">
                    <span className={`dropdown-button ${isTechnologiesActive ? 'active' : ''}`}>
                        Technologies
                    </span>
                    <div className="dropdown-content single-column">
                        <NavLink to="/core">Core</NavLink>
                        <NavLink to="/Radio">RF(Radio Frequency)</NavLink>
                        <NavLink to="/Wired">Wired</NavLink>
                        <NavLink to="/Software">IT Technology</NavLink>
                        <NavLink to="/network">Network</NavLink>
                        <NavLink to="/ML">Artificial intelligence and ML</NavLink>
                    </div>
                </div>
                <div className="dropdown">
                    <NavLink
                        to="/Product"
                        className={({ isActive }) =>
                            `dropdown-button ${isActive || isProductActive ? 'active' : ''}`
                        }
                    >
                        Product
                    </NavLink>
                    <div className="dropdown-content three-columns">
                        <NavLink to="/remote-gateways">Remote Gateways/RFID 2.4ghz/GSM/GPRS</NavLink>
                        <NavLink to="/Data-transfer-unit">Data Transfer Unit /RS485/RS232/gsm/gprs</NavLink>
                        <NavLink to="/rfid-tag">RFID Tag</NavLink>
                        <NavLink to="/RFID-Reader">RFID Reader</NavLink>
                        <NavLink to="/Asset-Monitoring-System">Asset Monitoring System</NavLink>
                        <NavLink to="/Metro-Water-Quality">Water Quality and Quantity</NavLink>
                        
                        <NavLink to="/Temperature-Monitoring-For-Cold-Storage">
                            Temperature Monitoring For Cold Storage
                        </NavLink>
                        <NavLink to="/Temperature-Monitoring-For-Food-and-Transport">
                            Telematics For Food and Transport
                        </NavLink>
                        <NavLink to="/FuelSensor">Fuel Sensor</NavLink>
                        <NavLink to="/lora-based-water-meter">LoRa Based Water Meter</NavLink>
                    </div>
                </div>
                <div className="dropdown dropdown-solutions">
                    <NavLink
                        to="/Solution1"
                        className={({ isActive }) =>
                            `dropdown-button ${isActive || isSolutionsActive ? 'active' : ''}`
                        }
                    >
                        Solutions
                    </NavLink>
                    <div className="dropdown-content three-columns">
                        <NavLink to="/Fuel-monitoring">Fuel Monitoring System</NavLink>
                        <NavLink to="/Battery-management">Battery Management Systems</NavLink>
                        <NavLink to="/AQUA">AQUA / Pond Monitoring</NavLink>
                        <div className="nested-dropdown">
                            <span className="nested-dropdown-button">Energy Solutions</span>
                            <div className="nested-dropdown-content">
                                <NavLink to="/AMRS">AMR Solution</NavLink>
                                <NavLink to="/Retrofit-AMR-solutions">Retrofit AMR Solution</NavLink>
                                <NavLink to="/Prepaid-meter-solution">Prepaid Meter Solution</NavLink>
                            </div>
                        </div>
                        <div className="nested-dropdown">
                            <span className="nested-dropdown-button">Automation Solutions</span>
                            <div className="nested-dropdown-content">
                                <NavLink to="/Street-light-control">Street Light Control</NavLink>
                                <NavLink to="/Water-quality-management-solution">
                                    Water Quality/Supply Management
                                </NavLink>
                                <NavLink to="/Management-of-lights-air-conditioning-fire-detection-surveillance">
                                    Management of Lights, Air Conditioning
                                </NavLink>
                            </div>
                        </div>
                        <div className="nested-dropdown">
                            <span className="nested-dropdown-button">Telematics Solutions</span>
                            <div className="nested-dropdown-content">
                                <NavLink to="/Vehicle-Tracking-System">Vehicle Tracking System</NavLink>
                                <NavLink to="/fuel-and-fleet-management">
                                    Fuel and Fleet Management System
                                </NavLink>
                                <NavLink to="/Person-tracking-system">
                                    Asset Tracking/Person Tracking System
                                </NavLink>
                            </div>
                        </div>
                        <NavLink to="/Weather-Monitoring">Weather Monitoring</NavLink>
                        <NavLink to="/Burgular-Alarm-System">Burglar Alarm System</NavLink>
                        <NavLink to="/Energy-monitoring-system">Energy Monitoring System</NavLink>
                        <NavLink to="/Food-chain-industries">Food Chain Industry</NavLink>
                        <NavLink to="/Fire-detection">Fire Detection</NavLink>
                        <NavLink to="/PMS-for-food-grade-industries">
                            Power Monitoring Solution For Various Food Grade Industries
                        </NavLink>
                        <NavLink to="/Telecom">Telecom</NavLink>
                        <NavLink to="/GIM">Green Infra Management</NavLink>
                        <NavLink to="/Airconditioner">Air Conditioner Automation</NavLink>

                    </div>
                </div>
                <NavLink to="/Careers" className={({ isActive }) => (isActive ? 'active' : '')}>
                    Careers
                </NavLink>
                <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')}>
                    Contact Us
                </NavLink>
            </nav>
            <div className="navbar-spacer"></div>
            <ChatBox />
        </>
    );
};

export default Navbar;